import accountsConfig from './accounts-config.json';

export enum StepsType {
  Instant = 'InstantFundedChallenge',
  OneStep = 'OneStepChallenge',
  TwoSteps = 'TwoStepsChallenge',
  ThreeSteps = 'ThreeStepsChallenge',
}

export enum AddonType {
  IncreasedLeverage = 'INCREASED_LEVERAGE',
  IncreasedProfitSplit = 'INCREASED_PROFIT_SPLIT',
  WeeklyPayouts = 'WEEKLY_PAYOUTS',
}
export const PriceTiers = {
  [StepsType.OneStep]: [
    {
      balance: 5000,
      price: 59,
    },
    {
      balance: 10000,
      price: 109,
    },
    {
      balance: 25000,
      price: 249,
    },
    {
      balance: 50000,
      price: 355,
    },
    {
      balance: 100000,
      price: 565,
    },
  ],
  [StepsType.TwoSteps]: [
    {
      balance: 5000,
      price: 49,
    },
    {
      balance: 10000,
      price: 89,
    },
    {
      balance: 25000,
      price: 239,
    },
    {
      balance: 50000,
      price: 340,
    },
    {
      balance: 100000,
      price: 549,
    },
  ],
  [StepsType.ThreeSteps]: [
    {
      balance: 5000,
      price: 35,
    },
    {
      balance: 10000,
      price: 55,
    },
    {
      balance: 25000,
      price: 145,
    },
    {
      balance: 50000,
      price: 245,
    },
    {
      balance: 100000,
      price: 385,
    },
  ],
  [StepsType.Instant]: [
    {
      balance: 3000,
      price: 29,
    },
    {
      balance: 6000,
      price: 59,
    },
    {
      balance: 10000,
      price: 99,
    },
    {
      balance: 15000,
      price: 149,
    },
    {
      balance: 25000,
      price: 249,
    },
    {
      balance: 50000,
      price: 499,
    },
  ],
};

export const BalanceTiers = {
  [StepsType.OneStep]: [5000, 25000, 10000, 50000, 100000],
  [StepsType.TwoSteps]: [5000, 25000, 10000, 50000, 100000],
  [StepsType.ThreeSteps]: [5000, 25000, 10000, 50000, 100000],
  [StepsType.Instant]: [3000, 6000, 10000, 15000, 25000, 50000],
  '': [5000, 25000, 10000, 50000, 100000],
};

export const Addons = [
  {
    name: 'Weekly Payouts',
    type: AddonType.WeeklyPayouts,
    percentage: 0.25,
    from: '14 days',
    to: 'Payouts every 7 days',
  },
  {
    name: 'Increased profit split',
    type: AddonType.IncreasedProfitSplit,
    percentage: 0.2,
    from: '75%',
    to: '85% Profit Split',
  },
  {
    name: 'Increased Leverage',
    type: AddonType.IncreasedLeverage,
    percentage: 0.1,
    from: '1:50',
    to: '1:75 (FX), 1:30 Gold',
  },
];

export const steps = [
  {
    title: 'Instant',
    description: [
      'instant.description1',
      'instant.description2',
      'instant.description3',
      'instant.description4',
    ],
    label: 'Instant',
    value: StepsType.Instant,
    decoration: 'NEW',
    rules: ' https://help.monevis.com/en/collections/13159246-instant-funding',
  },
  {
    title: 'One-Step',
    description: [
      'oneStep.description1',
      'oneStep.description2',
      'oneStep.description3',
      'oneStep.description4',
    ],
    label: 'Beginner',
    value: StepsType.OneStep,
    rules:
      'https://help.monevis.com/en/articles/11496460-monevis-1-step-challenge-overview',
  },
  {
    title: 'Two-Step',
    description: [
      'twoStep.description1',
      'twoStep.description2',
      'twoStep.description3',
      'twoStep.description4',
      'twoStep.description5',
    ],

    value: StepsType.TwoSteps,
    rules:
      'https://help.monevis.com/en/articles/8996635-monevis-2-step-challenge-overview',
  },
  {
    title: 'Three-Step',
    description: [
      'threeStep.description1',
      'threeStep.description2',
      'threeStep.description3',
      'threeStep.description4',
    ],
    label: 'Advanced',
    value: StepsType.ThreeSteps,
    rules:
      ' https://help.monevis.com/en/articles/11496472-monevis-3-step-challenge-overview',
  },
];

// @ts-expect-error -- ok
const _poorCountries = ['PK', 'ZA', 'IN', 'BD', 'NG', 'TZ'];

export function getTiers(accountType: StepsType | '') {
  // return BalanceTiers.filter((tier) => {
  //   return (
  //     ![5000].includes(tier) ||
  //     poorCountries.includes(country ?? '') ||
  //     tier === Number(hardBalance)
  //   );
  // }).sort((a, b) => a - b);

  return BalanceTiers[accountType].sort((a, b) => a - b);
}

export function findAccountId(
  initialBalance: number,
  addons: string[],
  phase: string,
): string | null {
  return (
    accountsConfig.find((account) => {
      const config = account.configuration;

      const configAddons = config.addons || [];
      const addonsMatch =
        configAddons.length === addons.length &&
        configAddons.every((addon) => addons.includes(addon)) &&
        addons.every((addon) => configAddons.includes(addon));

      return (
        config.initialBalance === initialBalance &&
        config.trackingModel === phase &&
        addonsMatch
      );
    })?.id ?? null
  );
}

export function getAccountConfigById(
  accountId: string,
): { id: string; configuration: unknown } | null {
  return accountsConfig.find((account) => account.id === accountId) ?? null;
}
